import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NewsList from '@src/pc/index/layout/NewsList';
import MediaNews from '@src/pc/index/layout/MediaNews';
import Banner from '@src/pc/index/layout/components/Banner';
import NavTitle from '@src/pc/index/layout/components/NavTitle/inde';
import Grid from '@src/pc/index/layout/Grid';
import Support from '@src/pc/index/layout/Support';
import NewsUL from '@src/pc/index/layout/NewsUL';
import TabContent from '@src/pc/index/layout/TabContent';
import LargeVideo from '@src/pc/index/layout/LargeVideo';
import ImageSwiper from '@src/pc/index/layout/ImageSwiper';
import ExclusiveVideo from '@src/pc/index/layout/ExclusiveVideo';
import LongImages from '@src/pc/index/layout/LongImages';
import Header from '@src/pc/index/layout/Header';
import Footer from '@src/pc/index/layout/Footer';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import { ChipMap } from '../chipMap';
import { Comment } from '@ifeng-fe/three_terminal/es/pc/comment';

const Layout = ({ content }) => {
    const GetContent = id => {
        switch (id) {
            case 'box1': {
                return (
                    <div key="box1">
                        <div className={styles.box1} key="box1" id="box1">
                            <NewsList content={content} />
                            <MediaNews content={content} />
                        </div>
                        <Chip key="NewsListSupport" {...ChipMap.NewsListSupport}>
                            {content.NewsListSupport && content.NewsListSupport.imgUrl ? (
                                <img src={content.NewsListSupport.imgUrl} alt="" style={{ marginTop: '20px' }} />
                            ) : null}
                        </Chip>
                    </div>
                );
            }
            case 'box2': {
                return (
                    <div className={styles.box2} key="box2" id="box2">
                        <Chip key="Title2" {...ChipMap.Title2} content={content.Title2}>
                            <NavTitle type="large" />
                        </Chip>
                        <Chip key="Kaimu1" {...ChipMap.Kaimu1} content={content.Kaimu1}>
                            <TabContent />
                        </Chip>
                    </div>
                );
            }
            case 'box3': {
                return (
                    <div className={styles.box3} key="box3" id="box3">
                        <Chip key="Title3" {...ChipMap.Title3} content={content.Title3}>
                            <NavTitle type="large" />
                        </Chip>
                        <Chip key="Grid1" {...ChipMap.Grid1} content={content.Grid1}>
                            <Grid />
                        </Chip>
                    </div>
                );
            }
            case 'box4': {
                return (
                    <div className={styles.box4} key="box4" id="box4">
                        <Chip key="Title4" {...ChipMap.Title4} content={content.Title4}>
                            <NavTitle type="large" />
                        </Chip>
                        <Chip key="LargeVideo" {...ChipMap.LargeVideo} content={content.LargeVideo}>
                            <LargeVideo />
                        </Chip>
                    </div>
                );
            }
            case 'box5': {
                return (
                    <div className={styles.box5} key="box5" id="box5">
                        <Chip key="Title5" {...ChipMap.Title5} content={content.Title5}>
                            <NavTitle type="large" />
                        </Chip>
                        <Chip key="exclusiveVideo" {...ChipMap.exclusiveVideo} content={content.exclusiveVideo}>
                            <ExclusiveVideo />
                        </Chip>
                    </div>
                );
            }

            case 'box8': {
                return (
                    <div className={styles.box8} key="box8" id="box8">
                        <Chip key="Title8" {...ChipMap.Title8} content={content.Title8}>
                            <NavTitle type="large" />
                        </Chip>
                        <Chip key="TuPianCeHua" {...ChipMap.TuPianCeHua} content={content.TuPianCeHua}>
                            <LongImages />
                        </Chip>
                    </div>
                );
            }

            case 'box6': {
                return (
                    <div className={styles.box6} key="box6" id="box6">
                        <Chip key="Title6" {...ChipMap.Title6} content={content.Title6}>
                            <NavTitle type="large" />
                        </Chip>
                        <Chip key="GaoQingDaTu" {...ChipMap.GaoQingDaTu} content={content.GaoQingDaTu}>
                            <ImageSwiper />
                        </Chip>
                    </div>
                );
            }
            case 'box7': {
                return (
                    <div className={styles.box7} key="box7" id="box7">
                        <Chip key="Title7" {...ChipMap.Title7} content={content.Title7}>
                            <NavTitle type="large" />
                        </Chip>
                        <div className={styles.flex}>
                            <div className={styles.left}>
                                <Chip key="NewsULTitle1" {...ChipMap.NewsULTitle1}>
                                    <Banner
                                        type="url"
                                        title={content.NewsULTitle1.title}
                                        url={content.NewsULTitle1.url}
                                    />
                                </Chip>
                                <Chip key="NewsUL1" {...ChipMap.NewsUL1} content={content.NewsUL1}>
                                    <NewsUL />
                                </Chip>

                                <Chip key="NewsULTitle2" {...ChipMap.NewsULTitle2}>
                                    <Banner
                                        type="url"
                                        title={content.NewsULTitle2.title}
                                        url={content.NewsULTitle2.url}
                                    />
                                </Chip>
                                <Chip key="NewsUL2" {...ChipMap.NewsUL2} content={content.NewsUL2}>
                                    <NewsUL />
                                </Chip>

                                <Chip key="NewsULTitle3" {...ChipMap.NewsULTitle3}>
                                    <Banner
                                        type="url"
                                        title={content.NewsULTitle3.title}
                                        url={content.NewsULTitle3.url}
                                    />
                                </Chip>
                                <Chip key="NewsUL3" {...ChipMap.NewsUL3} content={content.NewsUL3}>
                                    <NewsUL />
                                </Chip>
                            </div>
                            <div className={`${styles.right} ${styles.supportRight}`}>
                                <div className={styles.block}>
                                    <Chip key="Support" {...ChipMap.Support} content={content.Support}>
                                        <Support />
                                    </Chip>
                                </div>
                                <div className={styles.block}>
                                    <div className={styles.title} style={{ borderBottom: 'solid 1px #ddd' }}>
                                        版权声明
                                    </div>
                                    <div className={styles.title}>
                                        凤凰网{' '}
                                        <a href="https://finance.ifeng.com/" target="_blank">
                                            财经
                                        </a>{' '}
                                        中心出品，欢迎收藏。
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    };

    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
    
    return (
        <div className={styles.layout}>
            <Chip key="Layout" {...ChipMap.Layout} content={content['Layout']}>
                <div />
            </Chip>
            <Header searchData={content.Search} />
            <div className={styles.mainWp}>
                <div className={styles.mainImage}>
                    <Chip key="mainImage" {...ChipMap.mainImage}>
                        <img className={styles.banner} src={content.mainImage} alt="主图" />
                    </Chip>
                </div>
                <div className={styles.main}>
                    {content.Layout.map(item => {
                        return item.isShow ? GetContent(item.id) : null;
                    })}

                    <div className={styles.commentWp}>
                        <Comment
                            articleInfo={{
                                noAd: true,
                                // 文章单页的页面地址 commentUrl
                                docUrl: 'https://finance.ifeng.com/loc/special/xghg25',
                                // 文章的标题
                                docTitle: '财经频道香港回归25周年专题',
                                // 文章评论的skey，这个是在后端生成好后给到前端的，个性化页面没有skey的话，可以为空
                                skey: '',
                                // 兼容以后的专题评论
                                speUrl: '',
                                // 文章pc的页面地址
                                pcUrl: '',
                                // 获取评论内容接口
                                cmtNumUrl: `https://${ commentDomain }/get.php`,
                                // 评论内容字数长度
                                cmtLength: 1000,
                                // 提交评论内容接口
                                cmtPostUrl: `https://${ commentDomain }/post.php`,
                                // 最热评论数量
                                hotLimit: 2,
                                // 推荐评论接口
                                cmtVoteUrl: `https://${ commentDomain }/vote.php`,
                                // 现实回复的楼层
                                replyLimit: 3,
                                // 举报提交接口
                                jubUrl: `https://${ commentDomain }/report`,
                                // 举报次数，便于每次回调函数名不同
                                jubNum: 0,
                                // 是否是评论详情页面
                                isComment: false,
                                // docUrl: "ucms_86YOkEdIiC1"
                            }}
                        />
                    </div>
                </div>

                <Footer />
                <ChipEdit transform={chipDataTransform} />
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
